// extracted by mini-css-extract-plugin
export var aiStarIcon = "_7k-4";
export var closeButton = "_7k-6";
export var dismissButton = "_7k-3";
export var editImageWithAiContainer = "_7k-8";
export var imageUploadWrapper = "_7k-7";
export var misspelledWord = "_7k-5";
export var spellCheckContainer = "_7k-2";
export var spin = "_7k-1";
export var spinning = "_7k-0";